import type { Site } from "@/models/site"
import type { SiteUpdate } from "@/services/site"

import type { EditSiteSchema } from "./edit-site.schema"

export const siteToEditFormValues = (site: Site): EditSiteSchema => ({
  addressLine1: site.address?.address_line_1 ?? "",
  addressLine2: site.address?.address_line_2 ?? "",
  buildingArea: site.sqFt ?? "",
  buildingType: site.buildingType ?? "",
  city: site.address?.city ?? "",
  country: site.address?.country ?? "",
  name: site.name ?? "",
  postalCode: site.address?.postal_code ?? "",
  state: site.address?.state ?? "",
})

export const editFormValuesToSiteUpdates = (
  values: EditSiteSchema
): SiteUpdate => ({
  address: {
    address_line_1: values.addressLine1,
    address_line_2: values.addressLine2,
    city: values.city,
    country: values.country.toUpperCase(),
    postal_code: values.postalCode,
    state: values.state.toUpperCase(),
  },
  buildingType: values.buildingType,
  name: values.name,
  sqFt: values.buildingArea,
})
